/* asn1/lib/index */ function _(require, module, exports) {
    // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
    // If you have no idea what ASN.1 or BER is, see this:
    // ftp://ftp.rsa.com/pub/pkcs/ascii/layman.asc
    var Ber = require(46) /* ./ber/index */;
    // --- Exported API
    module.exports = {
        Ber: Ber,
        BerReader: Ber.Reader,
        BerWriter: Ber.Writer
    };
}
